import angular, {ITimeoutService, ILocationService, IAnchorScrollService} from 'angular';

export class ScrollService {
    static $inject = ['$anchorScroll', '$timeout', '$location'];

    constructor(
        protected $anchorScroll: IAnchorScrollService,
        protected $timeout: ITimeoutService,
        protected $location: ILocationService) {}

    /**
     * Scroller implementation that can scroll to an ID while accounting for the
     * header implementation's impact on the offset and updates the location hash.
     *
     * TODO: research whether the $timeout etc are really necessary. I feel like setting the offset when the header
     * is loaded would only require us navigating to the hash rather than explicitly calling $anchorScroll(). Or we
     * could check the hash on a state change event and scroll to then... hopefullt this will go away in a ng >=2.x
     * upgrade
     *
     * @param id html id of the component to scroll to.
     */
    public to(id: string): void {
        // needs $timeout: http://stackoverflow.com/a/22080470
        this.$timeout(() => {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            this.$location.hash(id);

            // targeting .main_header here causes failures on iOS, manually compute y-offset
            // TODO: Is this really necessary?
            let yOffset = 0;
            const $header: JQuery = angular.element('.main_header');
            if ($header && $header.length > 0) {
                if ($header.css('position') === 'fixed') {
                    const offset = $header.offset();
                    const height = $header.innerHeight();
                    yOffset = (offset?.top || 0) + (height || 0);
                }
            }
            this.$anchorScroll.yOffset = yOffset;
            // call $anchorScroll()
            this.$anchorScroll();
        });
    }
}